import api, { updateHeaderAuthorizationToken } from '../api';
import * as log from '../utils/log';
import { authentifyWallet } from '../wallet/api';
import { NotificationsService } from './notifications.service';
import TokenService from './token.service';
class AuthService {
    refresh(token) {
        return api.post('/auth/refresh', { token });
    }
    login(data) {
        return api.post('/auth/login', data);
    }
    signup(data) {
        return api.post('/auth/register', data);
    }
    confirm(token) {
        return api.post(`/auth/confirm`, { token });
    }
    changePassword(data) {
        return api.post('/auth/change-password', data);
    }
    recoveryPassword(email) {
        return api.post('/auth/forgot-password', { email });
    }
    confirmRecoveryPassword(token, password) {
        return api.post('/auth/confirm-reset-password', { token, password });
    }
    uploadPhoto(formData) {
        return api.post('/users/image', formData);
    }
    googleAuth(token) {
        return api.post('/auth/google', { token });
    }
    discordAuth(token) {
        return api.post('/auth/discord', { token });
    }
    deletePhoto() {
        return api.delete('/users/image');
    }
    setUserName(name) {
        return api.patch('/users', { name });
    }
    checkName(name) {
        return api.post('/users/check-name', { name });
    }
    async authenticateWallet(walletName) {
        // This part happens frontend in the connected wallet
        try {
            const authInfo = await authentifyWallet(walletName);
            // This part happens backend and validates the transaction in a safe
            // place where the user cannot spoof validity and returns a JWT token
            // which cannot be faked
            const verifyWallet = api.post('/auth/verify-sig', authInfo);
            NotificationsService.onWalletAuth(verifyWallet);
            return verifyWallet.then(({ data: tokenData }) => {
                this.setAuthTokens(tokenData);
                return tokenData;
            });
        }
        catch (e) {
            log.error('authenticateWallet error', e);
        }
    }
    setAuthTokens({ accessToken, refreshToken }) {
        TokenService.setWalletTokens(accessToken, refreshToken);
        updateHeaderAuthorizationToken(accessToken);
    }
}
export default new AuthService();
